<template>
	<div class="hd-moa-frame-nirm-screen-3">
		<base-image-svg
			class="js-moa-frame-nirm-screen-3 hd-moa-frame-nirm-screen-3__svg"
			:source="require('!html-loader!../../assets/svgs/18-moa-frame-nirm-screen-3-v1.svg')"
		/>
		<base-image-svg
			class="js-moa-frame-nirm-screen-3 hd-moa-frame-nirm-screen-3__svg hd-moa-frame-nirm-screen-3__svg--mobile"
			:source="require('!html-loader!../../assets/svgs/18-moa-frame-nirm-screen-3-v1-mobile.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-moa-frame-nirm-screen-3 {
		position: absolute;
		left: 0;
		bottom: 0;
		@include box(100%);

		&__svg {
			&--mobile.hd-base-image-svg {
				display: none;
			}
		}

		:deep() svg {
			padding-left: 150px;
			position: absolute;
			left: 0;
			@include center-y();
			width: 100%;
			@include fade-out();

			#Background_proteases {
				@include animation-float();
			}

			#Substrate_Pocket, #Label {
				@include fade-out();
				transform: translateX(5%);
			}
		}

		@include res-screen-portrait {
			:deep() svg {
				padding-left: 0;
			}
		}

		@include res-screen-portrait-sm {
			&__svg {
				display: none;

				&--mobile.hd-base-image-svg {
					display: flex;
				}
			}

			:deep() svg {
				padding-top: 80px;
			}
		}

		// Animation 
		[data-state="animation-ready"] {
			:deep() svg {
				opacity: 1;

				#Substrate_Pocket {
					@include transition-frame-fade-in();
					transition-delay: 0.5s;
				}

				#Label {
					@include transition-frame-fade-in();
					transition-delay: 0.75s;
				}
			}
		}
	}
</style>
